import { ScenarioQueryParams } from '@customer/store/apis/scenariosApi';
import LineChartScenario, {
  LineChartScenarioProps,
} from '../line-chart-scenario/LineChartScenario';
import { useCallback } from 'react';
import { CustomTimeRangeParams } from '@customer/store/apis/helpers';
import { useAppDispatch } from '@customer/store/hooks';
import { setPerformanceTimeRangeCustom } from '@customer/store/slices/globalSlice';

export type AreaChartScenarioProps = Omit<
  LineChartScenarioProps,
  'setCustomTimeRange' | 'clearCustomTimeRange'
>;

export const AreaChartScenario = <T extends ScenarioQueryParams>(props: AreaChartScenarioProps) => {
  const dispatch = useAppDispatch();

  const { enableCustomTimeRange } = props;

  // Todo: When custom time range selection is enabled for more than just performance scenarios, introduce a scenario check
  // on these callbacks to decide on the right slice action to dispatch.
  const setCustomTimeRange = useCallback(
    (customTimeRange: CustomTimeRangeParams) => {
      dispatch(setPerformanceTimeRangeCustom(customTimeRange));
    },
    [dispatch],
  );

  return (
    <LineChartScenario<T>
      {...props}
      filled={true}
      setCustomTimeRange={enableCustomTimeRange ? setCustomTimeRange : undefined}
    />
  );
};

export default AreaChartScenario;
